export enum OwnerType {
  ProductFamily = "product_family",
  Product = "product",
}
